import axios from "axios";

export default {
  getStartCharts() {
    return axios.get("https://api.investonom.com/api/v1/charts/start");
  }
};
